import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';

import { DEFAULT_SUPPORT_STEPS } from 'src/app/constants';
import { InboundEmailRule } from 'src/models';
import { ApiService } from 'src/services/api.service';
import { AuthService } from 'src/services/auth.service';
import { MessageService } from 'src/services/message.service';

@Component({
  selector: 'app-admin-support-step-rulesets',
  templateUrl: './admin-support-step-rulesets.component.html',
  styleUrls: ['./admin-support-step-rulesets.component.scss'],
})
export class AdminSupportStepRulesetsComponent implements OnInit {
  supportStepRulesets: Partial<any>[] | null;
  hasSupportStepRulesets = false;
  showingIndex = -1;

  constructor(
    public authService: AuthService,
    private msgSrvc: MessageService,
    private alertCtrl: AlertController,
    private apiService: ApiService,
  ) {}

  async ngOnInit() {
    await this.getSupportStepRulesets();
  }

  addSupportStepRuleset() {
    this.supportStepRulesets.push({
      rules: DEFAULT_SUPPORT_STEPS,
      name: '',
      description: '',
    });
    this.showingIndex = this.supportStepRulesets.length - 1;
  }

  async getSupportStepRulesets() {
    const result: any = await this.apiService.postPromise('/support-step-rulesets/list', {
      order: ['createdAt'],
      descending: false,
    });

    this.supportStepRulesets = result.data ?? null;
    this.hasSupportStepRulesets = !!this.supportStepRulesets.length;

    if (!this.hasSupportStepRulesets) {
      this.addSupportStepRuleset();
    }
  }

  async save(index: number) {
    try {
      const payload: Partial<InboundEmailRule> = this.supportStepRulesets[index];

      const _result = payload?.id
        ? await this.apiService.patchPromise(`/support-step-rulesets/${payload.id}`, payload)
        : await this.apiService.postPromise('/support-step-rulesets', payload);

      this.getSupportStepRulesets();

      this.msgSrvc.show('✔︎ Saved');
      this.showingIndex = -1;
    } catch (e) {
      this.msgSrvc.showError(e);
    }
  }

  supportStepsDidChange(supportSteps: any[], index: number) {
    this.supportStepRulesets[index].rules = supportSteps;
  }

  async delete(index: number) {
    if (!this.supportStepRulesets[index].id) {
      this.supportStepRulesets.pop();
      return;
    }

    const alert = await this.alertCtrl.create({
      header: 'Delete SLA',
      subHeader: 'Are you sure you want to delete this SLA?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Yes',
          handler: async () => {
            if (this.supportStepRulesets[index]) {
              await this.apiService.deletePromise(`/support-step-rulesets/${this.supportStepRulesets[index].id}`);

              this.getSupportStepRulesets();
            }
          },
        },
      ],
    });

    await alert.present();
  }

  toggleShowing(index: number) {
    const rule = this.supportStepRulesets[index];
    if (!rule?.id && this.hasSupportStepRulesets) {
      this.supportStepRulesets.pop();
      return;
    }

    if (this.showingIndex === index) {
      this.showingIndex = -1;
    } else {
      this.showingIndex = index;
    }
  }

  onRuleChannelChanged(rule, slackChannel, index: number) {
    rule.channelId = slackChannel?.id ?? null;
    rule.slackChannel = slackChannel;

    if (rule.id) {
      this.save(index);
    }
  }
}
